/** Мок API: покупки, награды, обмен. */
import { ApiError } from "@newfungame/contracts";
import type { FakeDb, FakeHandlers } from "./db";

export function economyHandlers(
  db: FakeDb,
): FakeHandlers<"purchase" | "claimOffline" | "claimStreak" | "claimTask" | "claimSeason" | "spend"> {
  return {
    purchase: async (req) => {
      const cost = 25;
      if (db.state.coins < cost) throw new ApiError("insufficient_coins");
      if (req.kind === "tech") {
        db.state = { ...db.state, tech: { ...db.state.tech, [req.techId]: (db.state.tech[req.techId] ?? 0) + 1 } };
      } else {
        db.state = {
          ...db.state,
          heroes: db.state.heroes.map((h) =>
            h.heroId !== req.heroId
              ? h
              : req.kind === "heroLevel"
                ? { ...h, level: h.level + 1 }
                : { ...h, stars: Math.min(5, h.stars + 1) },
          ),
        };
      }
      db.state = { ...db.state, coins: db.state.coins - cost };
      return { spent: cost, state: db.fresh() };
    },
    claimOffline: async () => {
      const coins = db.state.offline.coins;
      db.state = { ...db.state, coins: db.state.coins + coins, offline: { ...db.state.offline, coins: 0, seconds: 0 } };
      return { coinsAwarded: coins, state: db.fresh() };
    },
    claimStreak: async () => {
      if (db.state.streak.claimedToday) throw new ApiError("conflict", "already claimed");
      const coins = db.state.streak.todayReward;
      db.state = { ...db.state, coins: db.state.coins + coins, streak: { ...db.state.streak, claimedToday: true } };
      return { day: db.state.streak.day, coinsAwarded: coins, state: db.fresh() };
    },
    claimTask: async ({ task }) => {
      const tasks = db.state.tasks;
      if (!tasks) throw new ApiError("not_found", "no tasks");
      const row = tasks.tasks.find((t) => t.id === task);
      const done = tasks.tasks.every((t) => t.progress >= t.target);
      if (row ? row.claimed : tasks.bonus.claimed) return { task, coinsAwarded: 0, state: db.fresh() };
      if (row ? row.progress < row.target : !done) throw new ApiError("conflict", "not done");
      const coins = row ? row.coins : tasks.bonus.coins;
      db.state = {
        ...db.state,
        coins: db.state.coins + coins,
        tasks: row
          ? { ...tasks, tasks: tasks.tasks.map((t) => (t === row ? { ...t, claimed: true } : t)) }
          : { ...tasks, bonus: { ...tasks.bonus, claimed: true } },
      };
      return { task, coinsAwarded: coins, state: db.fresh() };
    },
    claimSeason: async () => ({ reward: { coins: 0, crystals: 0, skip: 0, speed: 0 }, state: db.fresh() }),
    spend: async () => {
      throw new ApiError("insufficient_crystals");
    },
  };
}
